import { CheckCircle2 } from "lucide-react";

export const optionLabel = (options, value) => options.find(([key]) => key === value)?.[1] || value || "Not provided";

export const JourneyField = ({ label, help, children }) => (
  <div>
    <label className="text-sm font-bold text-ink">{label}</label>
    {help && <p className="mt-1 text-xs leading-5 text-slatey">{help}</p>}
    <div className="mt-2">{children}</div>
  </div>
);

export const JourneyTextInput = ({ value, onChange, placeholder, testId }) => (
  <input value={value || ""} onChange={(event) => onChange(event.target.value)} data-testid={testId} placeholder={placeholder}
    className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-[15px] outline-none transition-colors focus:border-cobalt focus:ring-2 focus:ring-cobalt/15" />
);

export const JourneySelect = ({ value, onChange, options, placeholder, testId }) => (
  <select value={value || ""} onChange={(event) => onChange(event.target.value)} data-testid={testId}
    className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-[15px] outline-none focus:border-cobalt focus:ring-2 focus:ring-cobalt/15">
    <option value="">{placeholder}</option>
    {options.map(([valueOption, label]) => <option key={valueOption} value={valueOption}>{label}</option>)}
  </select>
);

export const JourneyChoiceGrid = ({ options, value, onChange, testId }) => (
  <div className="grid gap-3 sm:grid-cols-2" role="radiogroup" data-testid={testId}>
    {options.map(([key, label, description, badge]) => (
      <button type="button" key={key} onClick={() => onChange(key)} data-testid={`${testId}-${key}`} aria-pressed={value === key}
        className={`rounded-2xl border p-4 text-left transition-all ${value === key ? "border-cobalt bg-cobalt/5 ring-2 ring-cobalt/15" : "border-slate-200 bg-white hover:border-cobalt/40"}`}>
        <span className="flex items-start justify-between gap-3">
          <span className="font-bold text-ink">{label}</span>
          <span className="flex items-center gap-2">
            {badge && <span className="rounded-full bg-cobalt/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-cobalt">{badge}</span>}
            {value === key && <CheckCircle2 className="h-5 w-5 text-cobalt" />}
          </span>
        </span>
        {description && <span className="mt-1 block text-sm leading-6 text-slatey">{description}</span>}
      </button>
    ))}
  </div>
);
